module.exports = ".row:nth-child(odd){\r\n    background: #f2f2f2;\r\n}\r\n\r\n.row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row-custom{\r\npadding:10px 0px;\r\n}\r\n\r\n.reportlink{\r\n    display:inline-block;\r\n    padding:5px;\r\n    margin-right:15px;\r\n}\r\n\r\n.mandatory{\r\n    color:red;\r\n}\r\n\r\n.only-label{\r\n    margin-top: 5px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/rate-fixation/rate-form/rate-form.component.css
// module id = ./src/app/landprocurement/rate-fixation/rate-form/rate-form.component.css
// module chunks = main